
export const fieldFormatType = {
  integer: '#000',
  currency: '$0',
  percent: '00.00%'
}

/**
 * Format number list
 */
export const formatNumList = {
  '$0.00': (num) => {
    // backend settings
    return new Intl.NumberFormat(
            'zh-Hant', 
            { 
              style: 'currency',
              currency: 'TWD',
              currencyDisplay: 'symbol',
              currencySign: 'accounting',
              maximumFractionDigits: 2
            }).format(num);
  },
  '$00.00': (num) => {
    return new Intl.NumberFormat(
            'zh-Hant', 
            { 
              style: 'currency',
              currency: 'TWD',
              currencyDisplay: 'symbol',
              currencySign: 'accounting',
              maximumFractionDigits: 2
            }).format(num);
  },
  '$0': (num) => {
    return new Intl.NumberFormat(
            'zh-Hant', 
            { 
              style: 'currency',
              currency: 'TWD',
              currencyDisplay: 'symbol',
              currencySign: 'accounting',
              maximumFractionDigits: 0
            }).format(num);
  },
  '#000': (num) => {
    return new Intl.NumberFormat(
            'zh-Hant',
            {
              maximumFractionDigits: 0
            }).format(num);
  },
  '0': (num) => {
    // backend settings
    return new Intl.NumberFormat(
            'zh-Hant',
            {
              maximumFractionDigits: 0
            }).format(num);
  },
  '#0': (num) => {
    return new Intl.NumberFormat(
            'zh-Hant',
            {
              maximumFractionDigits: 0
            }).format(num);
  },
  '#00.00': (num) => {
    return new Intl.NumberFormat(
            'zh-Hant',
            {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            }).format(num);
  },
  '0.00%': (num) => {
    // backend settings
    return new Intl.NumberFormat(
            'zh-Hant',
            {
              style: 'percent',
              maximumFractionDigits: 2
            }).format(num);
  },
  '00.00%': (num) => {
    return new Intl.NumberFormat(
            'zh-Hant',
            {
              style: 'percent',
              maximumFractionDigits: 2
            }).format(num);
  }
}

export const formatNumber = (num, type) => {
  return formatNumList[type] ? formatNumList[type](num) : formatNumList['#000'](num);
}

export const formatFieldNumber = (num, type) => {
  type = fieldFormatType[type] || '#000';
  
  return formatNumList[type](num);
}

